// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"d54be86e","222":"fcbc67e5","246":"b5039c94","298":"9fe3ad27","363":"75537e3e","383":"57373ab9","422":"e0e7030d","463":"32b21cb5","475":"82582366","541":"c9a39af2","628":"204a8b6d","690":"2c62ca4b","724":"484c4545","870":"7116de8f","938":"cba041c2"}[chunkId] + ".chunk.js";
};